import { createSlice } from "@reduxjs/toolkit"

const slice = createSlice({
    name: 'supplyBill',
    initialState: {
        supplyBill: '',
        supplyBills: {
            list: [],
            checked: {},
            offset: 0,
            // limit: 10,
            limit: 20,
            count: 0,
            query: '',
            sort: {
                field: '',
                type: ''
            },
            filters: {
                status: 'work',
                paymentStatus: '',
                agreeNachSupply: '',
                agreeEconomist: '',
                agreeDeputyDirectorSupply: '',
                agreeHeader: '',
            }
        },
        supplyBillsItemsAll: { // Це список усіх позицій всіх рахунків
            list: [],
            offset: 0,
            limit: 10,
            count: 0,
            query: '',
            filters: {
                status: 'work', // Це статус рахунків, з яких треба показувати позиції
                agreeNachSupply: 'yes',
                agreeEconomist: 'yes',
                agreeDeputyDirectorSupply: 'yes',
                agreeHeader: 'other',
            }
        }
    },
    reducers: {
        setSupplyBill(state, action) {
            state.supplyBill = action.payload
        },
        setSupplyBillsList(state, action) {
            state.supplyBills.list = action.payload
        },
        editSupplyBillsListByBills(state, action) { // Оновлення наявних рахунків в залежності від отриманих
            if (state.supplyBills.list && state.supplyBills.list.length > 0) {
                state.supplyBills.list = state.supplyBills.list.map(item => {
                    let itemTemp = item
                    for (const itemNew of action.payload) {
                        if (item.id === itemNew.id) {
                            itemTemp = itemNew // Якщо є, то замінюємо на новий
                        }
                    }
                    return itemTemp
                })
            } else {
                state.supplyBills['list'] = [action.payload]
            }
        },
        setSupplyBillsChecked(state, action) {
            state.supplyBills.checked = action.payload
        },
        editSupplyBillsChecked(state, action) {
            if (state.supplyBills && state.supplyBills.checked) {
                const { name, value } = action.payload;
                state.supplyBills.checked[name] = value; 
            }
            // if (state.supplyBills && state.supplyBills.checked) {
            //     // console.log('FFFFF')
            //     console.log('state.supplyBills[checked]', state.supplyBills.checked)
            //     state.supplyBills['checked'] = state.supplyBills['checked'].map(item => {
            //         console.log('item', item)
            //         if (item.id === action.payload.id) {
            //             return action.payload
            //         } else {
            //             return item
            //         }
            //     })
            // } else {
            //     console.log('state.supplyBills[checked] 1', state.supplyBills.checked)
            //     state.supplyBills.checked = action.payload
            // }
        },
        setSupplyBillsOffset(state, action) {
            state.supplyBills.offset = action.payload
        },
        setSupplyBillsLimit(state, action) {
            state.supplyBills.limit = action.payload
        },
        setSupplyBillsCount(state, action) {
            state.supplyBills.count = action.payload
        },
        setSupplyBillsQuery(state, action) {
            state.supplyBills.query = action.payload
        },

        setSupplyBillsSortField(state, action) {
            state.supplyBills.sort.field = action.payload
        },
        setSupplyBillsSortType(state, action) {
            state.supplyBills.sort.type = action.payload
        },

        setSupplyBillsFiltersStatus(state, action) {
            state.supplyBills.filters.status = action.payload
        },
        setSupplyBillsFiltersPaymentStatus(state, action) {
            state.supplyBills.filters.paymentStatus = action.payload
        },
        editSupplyBillsFiltersAgreeNachSupply(state, action) {
            state.supplyBills.filters.agreeNachSupply = action.payload
        },
        editSupplyBillsFiltersAgreeEconomist(state, action) {
            state.supplyBills.filters.agreeEconomist = action.payload
        },
        editSupplyBillsFiltersAgreeDeputyDirectorSupply(state, action) {
            state.supplyBills.filters.agreeDeputyDirectorSupply = action.payload
        },
        editSupplyBillsFiltersAgreeHeader(state, action) {
            state.supplyBills.filters.agreeHeader = action.payload
        },
        addSupplyBill(state, action) {
            state.supplyBills.list.unshift(action.payload)
        },
        addSupplyBillUser(state, action) {
            if (state.supplyBill) {
                state.supplyBill['user'] = action.payload
            }
            // state.supplyBill.list.unshift(action.payload)
        },
        setSupplyBillItems(state, action) {
            if (state.supplyBill) {
                state.supplyBill['items'] = action.payload
            }
            // state.supplyBill.list.unshift(action.payload)
        },
        setSupplyBillPayment(state, action) {
            if (state.supplyBill) {
                state.supplyBill['payments'] = [action.payload]
            }
            // state.supplyBill.list.unshift(action.payload)
        },
        addSupplyBillPayment(state, action) {
            if (state.supplyBill) {
                if (state.supplyBill['payments']) {
                    state.supplyBill['payments'].unshift(action.payload)
                } else {
                    state.supplyBill['payments'] = [action.payload]
                }
            }
            // state.supplyBill.list.unshift(action.payload)
        },
        addSupplyBillDeliveries(state, action) {
            if (state.supplyBill) {
                if (state.supplyBill['deliveries']) {
                    state.supplyBill['deliveries'].unshift(action.payload)
                } else {
                    state.supplyBill['deliveries'] = [action.payload]
                }
            }
            // state.supplyBill.list.unshift(action.payload)
        },
        editSupplyBillDelivery(state, action) {
            if (state.supplyBill) {
                if (state.supplyBill['deliveries']) {
                    state.supplyBill['deliveries'] = state.supplyBill['deliveries'].map(delivery => {
                        if (delivery.id === action.payload.id) {
                            return action.payload
                        } else {
                            return delivery
                        }
                    })
                    // state.supplyBill['deliveries'].unshift(action.payload)
                } else {
                    state.supplyBill['deliveries'] = [action.payload]
                }
            }
            // state.supplyBill.list.unshift(action.payload)
        },
        editSupplyBillItems(state, action) {
            if (state.supplyBill) {
                state.supplyBill['items'] = action.payload
            }
            // state.supplyBill.list.unshift(action.payload)
        },

        editSupplyBillItem(state, action) {
            if (state.supplyBill && state.supplyBill.items) {
                state.supplyBill['items'] = state.supplyBill['items'].map(item => {
                    if (item.id === action.payload.id) {
                        return action.payload
                    } else {
                        return item
                    }
                })
            }
        },

        deleteSupplyBillItem(state, action) {
            if (state.supplyBill && state.supplyBill.items) {
                state.supplyBill.items = state.supplyBill.items.filter(
                    item => item.id !== action.payload.id
                )
            }
        },

        // editSupplyBillItemIsAgreeEconomist(state, action) {
        //     if (state.supplyBill && state.supplyBill.items) {
        //         state.supplyBill['items'] = state.supplyBill['items'].map(item => {
        //             if (item.id === action.payload.id) {
        //                 const itemNew = {
        //                     ...item,
        //                     isAgreeEconomist: action.payload.isAgreeEconomist
        //                 }
        //                 return itemNew
        //             } else {
        //                 return item
        //             }
        //         })
        //     }
        // },
        // editSupplyBillItemIsAgreeSupplyLeader(state, action) {
        //     if (state.supplyBill && state.supplyBill.items) {
        //         state.supplyBill['items'] = state.supplyBill['items'].map(item => {
        //             if (item.id === action.payload.id) {
        //                 const itemNew = {
        //                     ...item,
        //                     isAgreeSupplyLeader: action.payload.isAgreeSupplyLeader
        //                 }
        //                 return itemNew
        //             } else {
        //                 return item
        //             }
        //         })
        //     }
        // },
        // editSupplyBillItemIsAgreeLeadership(state, action) {
        //     if (state.supplyBill && state.supplyBill.items) {
        //         state.supplyBill['items'] = state.supplyBill['items'].map(item => {
        //             if (item.id === action.payload.id) {
        //                 const itemNew = {
        //                     ...item,
        //                     isAgreeLeadership: action.payload.isAgreeLeadership
        //                 }
        //                 return itemNew
        //             } else {
        //                 return item
        //             }
        //         })
        //     }
        // },


        // supplyBillsItemsAll
        setSupplyBillsItemsAllList(state, action) {
            state.supplyBillsItemsAll.list = action.payload
        },
        setSupplyBillsItemsAllOffset(state, action) {
            state.supplyBillsItemsAll.offset = action.payload
        },
        setSupplyBillsItemsAllLimit(state, action) {
            state.supplyBillsItemsAll.limit = action.payload
        },
        setSupplyBillsItemsAllCount(state, action) {
            state.supplyBillsItemsAll.count = action.payload
        },
        setSupplyBillsItemsAllQuery(state, action) {
            state.supplyBillsItemsAll.query = action.payload
        },
        editSupplyBillsItemsAllItem(state, action) {
            if (state.supplyBillsItemsAll && state.supplyBillsItemsAll.list && state.supplyBillsItemsAll.list.length > 0) {
                state.supplyBillsItemsAll.list = state.supplyBillsItemsAll.list.map(item => {
                    if (item.id === action.payload.id) {
                        return action.payload
                    } else {
                        return item
                    }
                })
            }
        },
        editSupplyBillsItemsFiltersStatus(state, action) {
            state.supplyBillsItemsAll.filters.status = action.payload
        },
        editSupplyBillsItemsFiltersAgreeNachSupply(state, action) {
            state.supplyBillsItemsAll.filters.agreeNachSupply = action.payload
        },
        editSupplyBillsItemsFiltersAgreeEconomist(state, action) {
            state.supplyBillsItemsAll.filters.agreeEconomist = action.payload
        },
        editSupplyBillsItemsFiltersAgreeDeputyDirectorSupply(state, action) {
            state.supplyBillsItemsAll.filters.agreeDeputyDirectorSupply = action.payload
        },
        editSupplyBillsItemsFiltersAgreeHeader(state, action) {
            state.supplyBillsItemsAll.filters.agreeHeader = action.payload
        },
        // setSupplyBillsItemsAllIsAgreeEconomist(state, action) {
        //     if (state.supplyBillsItemsAll && state.supplyBillsItemsAll.list && state.supplyBillsItemsAll.list.length > 0) {
        //         state.supplyBillsItemsAll.list = state.supplyBillsItemsAll.list.map(item => {
        //             if (item.id === action.payload.id) {
        //                 const itemNew = {
        //                     ...item,
        //                     isAgreeEconomist: action.payload.isAgreeEconomist
        //                 }
        //                 return itemNew
        //             } else {
        //                 return item
        //             }
        //         })
        //     }
        // },
        // setSupplyBillsItemsAllIsAgreeSupplyLeader(state, action) {
        //     if (state.supplyBillsItemsAll && state.supplyBillsItemsAll.list && state.supplyBillsItemsAll.list.length > 0) {
        //         state.supplyBillsItemsAll.list = state.supplyBillsItemsAll.list.map(item => {
        //             if (item.id === action.payload.id) {
        //                 const itemNew = {
        //                     ...item,
        //                     isAgreeSupplyLeader: action.payload.isAgreeSupplyLeader
        //                 }
        //                 return itemNew
        //             } else {
        //                 return item
        //             }
        //         })
        //     }
        // },
        // setSupplyBillsItemsAllIsAgreeLeadership(state, action) {
        //     if (state.supplyBillsItemsAll && state.supplyBillsItemsAll.list && state.supplyBillsItemsAll.list.length > 0) {
        //         state.supplyBillsItemsAll.list = state.supplyBillsItemsAll.list.map(item => {
        //             if (item.id === action.payload.id) {
        //                 const itemNew = {
        //                     ...item,
        //                     isAgreeLeadership: action.payload.isAgreeLeadership
        //                 }
        //                 return itemNew
        //             } else {
        //                 return item
        //             }
        //         })
        //     }
        // },
    }
})

export default slice.reducer

export const {
    setSupplyBill,
    setSupplyBillsList,
    editSupplyBillsListByBills,
    setSupplyBillsChecked,
    editSupplyBillsChecked,
    setSupplyBillsOffset,
    setSupplyBillsLimit,
    setSupplyBillsCount,
    setSupplyBillsQuery,

    setSupplyBillsSortField,
    setSupplyBillsSortType,

    setSupplyBillsFiltersStatus,
    setSupplyBillsFiltersPaymentStatus,
    editSupplyBillsFiltersAgreeNachSupply,
    editSupplyBillsFiltersAgreeEconomist,
    editSupplyBillsFiltersAgreeDeputyDirectorSupply,
    editSupplyBillsFiltersAgreeHeader,
    addSupplyBill,
    addSupplyBillUser,
    setSupplyBillItems,
    setSupplyBillPayment,
    addSupplyBillPayment,
    addSupplyBillDeliveries,
    editSupplyBillDelivery,
    editSupplyBillItems,
    editSupplyBillItem,
    deleteSupplyBillItem,

    // editSupplyBillItemIsAgreeEconomist,
    // editSupplyBillItemIsAgreeSupplyLeader,
    // editSupplyBillItemIsAgreeLeadership,

    // supplyBillsItemsAll
    setSupplyBillsItemsAllList,
    setSupplyBillsItemsAllOffset,
    setSupplyBillsItemsAllLimit,
    setSupplyBillsItemsAllCount,
    setSupplyBillsItemsAllQuery,
    editSupplyBillsItemsAllItem,

    editSupplyBillsItemsFiltersStatus,
    editSupplyBillsItemsFiltersAgreeNachSupply,
    editSupplyBillsItemsFiltersAgreeEconomist,
    editSupplyBillsItemsFiltersAgreeDeputyDirectorSupply,
    editSupplyBillsItemsFiltersAgreeHeader,
    // setSupplyBillsItemsAllIsAgreeEconomist,
    // setSupplyBillsItemsAllIsAgreeSupplyLeader,
    // setSupplyBillsItemsAllIsAgreeLeadership,
} = slice.actions